/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/App/Auth/SignUp/Email",
  isInvalid,
  onChange,
  onSubmit
  
}) {
let signupEmailValueData = fromData.useDataValue({ viewPath,
context: 'signup',
path: 'email',
})
let signupEmailIsValidData = fromData.useDataIsValid({ viewPath,
context: 'signup',
path: 'email',
validate: fromValidate.email,
})
let signupEmailChangeData = fromData.useDataChange({ viewPath,
context: 'signup',
path: 'email',
})
let signupEmailSubmitData = fromData.useDataSubmit({ viewPath,
context: 'signup',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 required={true}
 data="signup.email"
 validate="/Data/validate.js email"
 invalid={!signupEmailIsValidData}
 value={signupEmailValueData}
 onChange={signupEmailChangeData}
 onSubmit={signupEmailSubmitData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="email"
 autoFocus={true}
 placeholder="you@email.com"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}